<template>
  <transition name="modal">
    <div class="vcv-modal-background">
      <div
        v-if="withoutClickAway"
        class="vcv-modal-container"
        :style="`min-width:${width}px; min-height:${height}px; max-width:${width}px;`"
      >
        <div v-if="!withoutClose" class="vcv-modal__close-wrapper" @click="close">
          <i class="vcv-modal__close-btn icon icon-close"></i>

          <div class="vcv-modal__close-btn-esc">Esc</div>
        </div>

        <div class="vcv-modal__header">
          <slot name="header"></slot>
          <i v-if="!withoutClose" class="close-mobile icon icon-close" @click="close"></i>
        </div>

        <div class="vcv-modal__body">
          <slot name="body"></slot>
        </div>

        <div class="vcv-modal__footer">
          <slot name="footer"></slot>
        </div>
      </div>

      <div
        v-else
        v-on-click-away="close"
        class="vcv-modal-container"
        :style="`min-width:${width}px; min-height:${height}px; max-width:${width}px;`"
      >
        <div v-if="!withoutClose" class="vcv-modal__close-wrapper" @click="close">
          <i class="vcv-modal__close-btn icon icon-close"></i>

          <div class="vcv-modal__close-btn-esc">Esc</div>
        </div>

        <div class="vcv-modal__header">
          <slot name="header"></slot>
          <i v-if="!withoutClose" class="close-mobile icon icon-close" @click="close"></i>
        </div>

        <div class="vcv-modal__body">
          <slot name="body"></slot>
        </div>

        <div class="vcv-modal__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { directive as VueClickAway } from 'vue-clickaway';

export default {
  name: 'VcvModal',

  directives: {
    onClickAway: VueClickAway
  },

  props: {
    width: {
      type: Number,
      default: 650
    },

    height: {
      type: Number,
      default: 550
    },

    withoutClose: {
      type: Boolean,
      default: false
    },

    withoutClickAway: {
      type: Boolean,
      default: false
    }
  },

  created() {
    if (!this.withoutClose) {
      document.addEventListener('keyup', this.closeKeyHelper);
    }
  },

  beforeDestroy() {
    document.removeEventListener('keyup', this.closeKeyHelper);
  },

  methods: {
    close() {
      if (this.withoutClose) {
        return;
      }

      this.$emit('close');
    },

    closeKeyHelper(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vcv-modal-background {
  position: fixed;
  z-index: 9990;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vcv-modal-container {
  max-height: calc(100% - 165px);
  position: relative;
  border-radius: 2px;
  box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    position: fixed;
    min-width: 100% !important;
    max-width: 100% !important;
    min-height: 100dvh !important;
    border-top: 1px solid $gray-basic;
  }
}

.vcv-modal {
  &__close-wrapper {
    width: 46px;
    height: 56px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px 0;
    position: absolute;
    top: 0;
    right: -55px;
    box-shadow: $box-shadow;
    border: 1px solid $grey-light;
    cursor: pointer;
    transition: color 0.3s;

    &:hover > .vcv-modal__close-btn {
      color: $green-hover;
      transition: color 0.3s;
    }

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  &__close-btn {
    color: $main-dark;
    font-size: 20px;
  }

  &__close-btn-esc {
    color: $grey-darker;
    font-size: 12px;
    user-select: none;

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  &__header {
    display: flex;
    padding: 10px 20px;
    border-bottom: 1px solid $gray-basic;
  }

  &__body {
    height: 100%;
    flex: 1;
    margin-bottom: auto;
    overflow-y: auto;
  }

  &__footer {
    // padding: 10px 20px;
    // border-top: 1px solid $gray-basic;
  }
}

.close-mobile {
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    align-self: flex-end;
    margin-left: auto;
    cursor: pointer;
  }
}
</style>
